<template>
  <v-container
    id="userSettings"
    class="px-0"
    fluid
  >
    <portal to="page-title">
      <v-breadcrumbs :items="[{ text: $tc('labels.user', 2), disabled: false }, { text: $tc('labels.setting', 2), disabled: false }]">
        <template v-slot:divider>
          <v-icon size="8">
            far fa-chevron-right
          </v-icon>
        </template>
      </v-breadcrumbs>
    </portal>
    <v-card
      class="mx-10 my-3 settings"
      elevation="4"
    >
      <ValidationObserver v-slot="{ invalid, passes }">
        <v-container
          class="pa-4"
          fluid
        >
          <v-row dense>
            <v-col>
              <span class="body-2 font-weight-medium text--grey text--darken-3">
                {{ $t('labels.profileStateChanges') }}
              </span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="py-0">
              <!-- eslint-disable vue/no-v-html -->
              <span
                class="caption grey--text text--darken-1"
                v-html="$t('descriptions.profileStateChangesInactive')"
              />
            </v-col>
          </v-row>
          <v-row
            class="my-2"
            dense
          >
            <v-col
              class="state-flags pr-4"
              cols="6"
            >
              <FlagSelection
                ref="selectShiftFlag"
                v-model="states.inactive.flags"
                small-chips
                class="shift-flags"
                dense
                :filter="flagsFilter"
                hide-details
                item-text="shortCode"
                item-value="id"
                :items="shiftFlags"
                :label="$tc('labels.flag', 2)"
                multiple
                outlined
                :return-object="false"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="py-0">
              <!-- eslint-disable vue/no-v-html -->
              <span
                class="caption grey--text text--darken-1"
                v-html="$t('descriptions.profileStateChangesSevered')"
              />
            </v-col>
          </v-row>
          <v-row
            class="my-2"
            dense
          >
            <v-col
              class="state-flags pr-4"
              cols="6"
            >
              <FlagSelection
                ref="selectShiftFlag"
                v-model="states.severed.flags"
                small-chips
                class="shift-flags"
                dense
                :filter="flagsFilter"
                hide-details
                item-text="shortCode"
                item-value="id"
                :items="shiftFlags"
                :label="$tc('labels.flag', 2)"
                multiple
                outlined
                :return-object="false"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-divider />
        <v-row
          class="pa-4"
          dense
        >
          <v-spacer />
          <v-col
            class="text-right"
            cols="6"
          >
            <v-btn
              class="ml-3 save-settings"
              color="secondary"
              :disabled="invalid || saving"
              @click="passes(save)"
            >
              <v-progress-circular
                v-if="saving"
                color="secondary"
                indeterminate
                size="22"
                width="2"
              />
              <span v-else>
                {{ $t('labels.save') }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { showStatus } from '@/plugins/vue-notification';
import FlagSelection from '@/components/scheduling/FlagSelection';

export default {
  components: {
    FlagSelection
  },
  data () {
    return {
      saving: false,
      states: {
        inactive: {
          flags: _.cloneDeep(_.get(this.$store.state.org, ['settings', 'profile', 'states', 'inactive', 'flags'], []))
        },
        severed: {
          flags: _.cloneDeep(_.get(this.$store.state.org, ['settings', 'profile', 'states', 'severed', 'flags'], []))
        }
      }
    };
  },
  computed: {
    shiftFlags () {
      return _.filter(_.sortBy(this.$store.state.org.flags, ['name']), (f) => !f.working);
    }
  },
  methods: {
    // This function is added mainly for easy of mocking during in unit tests.
    dispatch (action, payload) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(action, payload).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    flagsFilter (item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.shortCode.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    save () {
      if (!this.saving) {
        this.saving = true;
        const settings = [
          {
            path: ['profile', 'states', 'inactive', 'flags'],
            value: this.states.inactive.flags
          },
          {
            path: ['profile', 'states', 'severed', 'flags'],
            value: this.states.severed.flags
          }
        ];
        this.dispatch('org/updateHospitalSettings', settings).then(() => {
          showStatus({
            text: this.$t('descriptions.userSettingsUpdateSuccess'),
            type: 'success'
          });
        }).catch(error => {
          const data = {
            error: _.get(error, 'response.data')
          };

          showStatus({
            text: this.$t('descriptions.userSettingsUpdateFail'),
            type: 'error',
            data
          });
        }).finally(() => {
          this.saving = false;
        });
      }
    }
  }
};
</script>

<style lang="scss">
#userSettings {
  .settings {
    min-width: 600px;
    overflow-x: hidden;
  }
}
</style>
